module.exports = __webpack_public_path__ + "img/ben.d2d05616.png";